module.exports = __webpack_public_path__ + "img/mbBanner19.b707abcd.png";